import { use } from 'react';

import { useTranslations } from 'use-intl';

import { SharedSurveyProgressRing } from '@/shared-survey';
import { SurveyThemeContext } from '@/shared-utilities';

import { type ViewMode } from './survey-ai-forms.types';

interface Props {
  progress: number;
  estimatedTotalTimeInSeconds: number;
  viewMode: ViewMode;
  onViewModeToggle?: () => void;
  isFormSection?: boolean;
}

export default function SurveyAiFormsAiSectionMobileHeader({
  progress,
  estimatedTotalTimeInSeconds,
  isFormSection = false,
}: Props) {
  const t = useTranslations('Common');

  const { input } = use(SurveyThemeContext);

  const orgSettings = input?.orgSettings;

  return (
    <div
      data-test='mobile-header'
      className='flex items-center justify-between p-4'
    >
      {/* Logo */}
      {orgSettings?.logoUrl ? (
        <img
          src={orgSettings.logoUrl}
          alt={t('logoAlt')}
          data-test='header-logo'
          className='h-12 w-auto object-contain'
        />
      ) : (
        <div className='size-12'></div>
      )}

      {/* Progress Ring */}
      <SharedSurveyProgressRing
        estimatedTotalTimeInSeconds={estimatedTotalTimeInSeconds}
        progress={progress}
        size={48}
        strokeWidth={3}
        backgroundColor='#e5e7eb'
        textColor={isFormSection ? '#000000' : 'var(--brand-secondary)'}
      />
    </div>
  );
}
